package net.frozenbit.games.soundgame.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.text.input.InputTransformation
import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.viewmodels.ControllerViewModel

@Composable
internal fun ControllerPreGameScreen(
    joinCodeState: TextFieldState,
    joinCodeTransformation: InputTransformation,
    controllerUiState: ControllerViewModel.ControllerUiState.Idle,
    playerNameState: TextFieldState,
    loading: Boolean,
    onJoinGameClick: () -> Unit,
) {
    TextField(
        placeholder = { Text("Code (XXX)") },
        state = joinCodeState,
        inputTransformation = joinCodeTransformation,
        keyboardOptions = KeyboardOptions(
            capitalization = KeyboardCapitalization.Characters,
            autoCorrectEnabled = false,
        ),
    )
    controllerUiState.errorMessage?.let { errorMessage ->
        Text(
            text = errorMessage,
            color = Color.Red,
            modifier = Modifier
                .background(Color.White, shape = RoundedCornerShape(4.dp))
                .padding(8.dp)
        )
    }
    TextField(
        placeholder = { Text("Dein Spielername") },
        state = playerNameState,
        keyboardOptions = KeyboardOptions(
            capitalization = KeyboardCapitalization.Characters,
            autoCorrectEnabled = false,
        ),
    )
    if (loading) {
        CircularProgressIndicator()
    } else {
        Button(
            onClick = { onJoinGameClick() },
        ) {
            Text("Beitreten")
        }
    }
}